import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import './App.css'
import { FullscreenProvider } from './context/FullScreenContext'
import Login from './login-module/login'
import Introduction from './intro-module/Introduction'
import UserType from './nativeHelperComponents/userType'
import ClaimsDisplay from './home/allclaims'
import ReviewComponent from './home/review'
import Layout from './home/topbar'
import ClaimTrackingUI from './home/claimLanding'
import ApprovedClaimsList from './home/approveclaims'
import DiscrepancyList from './home/discrepancies'
import ClaimForm from './home/claimform'
import DocumentStatus from './home/document'
import SurveyStatus from './home/tickets'
import Home from './home/home'
import InspectionMethod from './audit-creation-module/inspection-mode/InspectionMethod'
import InspectionMethodOption from './audit-creation-module/inspection-mode/InspectionMethodOption'
import Uploaddocs from './home/Uploaddocs'
import Permission from './camera-module/location-camera-permission/Permission'
import StartInspection from './camera-module/instructions-module/StartInspection'
import CameraModule from './camera-module/Camera'
import AdditionalCamera from './camera-module/AdditionalCamera'
import Processing from './audit-completion-module/Processing'
import UpdateInfoPage from './home/UpdateInfoPage'
import UpdateInfoPageManual from './home/UpdateInfoPageManual'
import UpdateInfoClaimManual from './home/UpdateInfoClaimManual'
import PostRepair from './home/postrepairprocess'
import RepairProcess from './home/repairprocess'
import UpdateInvoice from './home/updateinvoice'
import AdditionalDocuments from './home/preinvoice-invoice'
import ManualQc from './home/manualqc'
import PreInvoiceDocumentStatus from './home/invoice_and_document'
import ProcessComplete from './home/finalpage'
import InitialAssessmentReport from './home/Report/InitialAssessmentReport'
import InitialClaimReport from './home/Report/InitialClaimReport'
import FinalClaimReport from './home/Report/FinalClaimReport'
import PermissionRetake from './camera-module/location-camera-permission/PermissionRetake'
import StartInspectionRetake from './camera-module/instructions-module/StartInspectionRetake'
import ProcessingRetake from './audit-completion-module/ProcessingRetake'
import InitialAssessmentReportManual from './home/Report/InitialAssessmentReportManual'
import InitialClaimReportManual from './home/Report/InitialClaimReportManual'
import WorkApprovalReport from './home/Report/workapproval'
import ClaimApprovalReport from './home/Report/ClaimApprovalReport'
import PSUReport from './home/Report/PSUReport'
import FinalSurveyReport from './home/Report/FinalSurveyReport';
import PermissionVideo
  from './video-module/location-camera-audio-permission/Permission';
import StartInspectionVideo
  from './video-module/instructions-module/StartInspection';
  
import StartInspectionVideoModule
  from './camera-module/instructions-module/StartInspectionVideoModule';
import VideoInstruction
  from './video-module/instructions-module/VideoInstruction';
import VideoRecorder from './video-module/VideoModule';  
import VideoTimer from './video-module/video-timer/VideoTimer';
import ProcessingVideo
  from './audit-completion-module/video-module-completion/Processing';
function App() {
  return (
    <Router>
      <FullscreenProvider>
        <div style={{ height: '100vh', overflow: 'auto' }}>
          <Routes>
            {/* <Route path="/" element={<Introduction />} /> */}
            <Route path='/userType' element={<UserType />} />
            <Route path='/' element={<Login />} />

            <Route element={<Layout />}>
              <Route path='/home' element={<Home />} />
              <Route path='tickets' element={<SurveyStatus />} />
              <Route path='claims' element={<ApprovedClaimsList />} />
              <Route path='discrepancies' element={<DiscrepancyList />} />
              <Route path='/create-claim' element={<ClaimForm />} />
              <Route path='/claim-display' element={<ClaimsDisplay />} />
              <Route
                path='/review-page/:claimNumber'
                element={<ReviewComponent />}
              />
              <Route
                path='/claimLanding/:claimNumber'
                element={<ClaimTrackingUI />}
              />
              <Route
                path='/document-page/:claimNumber'
                element={<DocumentStatus />}
              />
              <Route
                path='/ticket-page/:claimNumber'
                element={<SurveyStatus />}
              />
              <Route
                path='/update-info/:claimNumber'
                element={<UpdateInfoPage />}
              />
              <Route
                path='/re-inspection-upload/:claimNumber'
                element={<PostRepair />}
              />
              <Route
                path='/under-repair-upload/:claimNumber'
                element={<RepairProcess />}
              />
              <Route
                path='/re-inspection-documents/:claimNumber'
                element={<UpdateInvoice />}
              />
              <Route
                path='/under-repair-documents/:claimNumber'
                element={<PreInvoiceDocumentStatus />}
              />
              <Route
                path='/payment-page/:claimNumber'
                element={<ProcessComplete />}
              />
              <Route
                path='/manual-qc/:claimNumber'
                element={<UpdateInfoPageManual />}
              />
              
              {/* PSU Report Report added in lyout*/}
              <Route
                path="/psu-report/:claimNumber"
                element={<PSUReport />}
              />

              {/* Final Survey Report added in lyout */}
              <Route
                path="/final-survey-report/:claimNumber"
                element={<FinalSurveyReport />}
              />

              {/* Report routes which already inside */}
              <Route
                path='/initial-report/:claimNumber'
                element={<InitialAssessmentReport />}
              />
              <Route
                path='/initial-report-manual/:claimNumber'
                element={<InitialAssessmentReportManual />}
              />
              <Route
                path='/initial-claim-report/:claimNumber'
                element={<InitialClaimReport />}
              />
              <Route
                path='/initial-claim-report-manual/:claimNumber'
                element={<InitialClaimReportManual />}
              />
              <Route
                path='/approve-claim/:claimNumber'
                element={<WorkApprovalReport />}
              />
              <Route
                path='/approve-claim-report/:claimNumber'
                element={<ClaimApprovalReport />}
              />

              {/* manual-qc-claim */}
              <Route
                path='/manual-qc-claim/:claimNumber'
                element={<UpdateInfoClaimManual />}
              />
              
              {/* ✅ FIXED: upload docs for inspection mode - NOW INSIDE LAYOUT */}
              <Route
                path='/upload-docs/:claimNumber'
                element={<Uploaddocs />}
              />
            </Route>

            {/* ------------ outer routes without layout ------------ */}
            <Route
              path='/initial-report-manual/:claimNumber'
              element={<InitialAssessmentReportManual />}
            />
            <Route
              path='/preinvoice-invoice/:claimNumber'
              element={<AdditionalDocuments />}
            />
            <Route
              path='/approve-claim/:claimNumber'
              element={<WorkApprovalReport />}
            />

            {/* claim report */}
            <Route
              path='/initial-claim-report/:claimNumber'
              element={<InitialClaimReport />}
            />
            <Route
              path='/final-claim-report/:claimNumber'
              element={<FinalClaimReport />}
            />

            {/* direct approve claim report */}
            <Route
              path='/approve-claim-report/:claimNumber'
              element={<ClaimApprovalReport />}
            />

            {/* Approve finish manual qc */}
            <Route
              path='/initial-claim-report-manual/:claimNumber'
              element={<InitialClaimReportManual />}
            />

            {/*----------------- inspection route------------ */}
            <Route
              exact
              path='/audit/inspection/mode/:claimNumber'
              element={<InspectionMethod />}
            />

            {/* new route InspectionMethodOption added here */}   
            <Route
              exact
              path='/audit/inspection/mode-options/:claimNumber'
              element={<InspectionMethodOption />}
            />

            {/* Photo Mode Routes */}
            <Route
              exact
              path='/audit/photo/permission/:claimNumber'
              element={<Permission />}
            />
            <Route
              exact
              path='/audit/photo/:claimNumber'
              element={<StartInspection />}
            />
            <Route path='/camera/:claimNumber' element={<CameraModule />} />
            <Route path='/additional-flow/:claimNumber' element={<AdditionalCamera />} />
            <Route path='/processing/:claimNumber' element={<Processing />} />
             {/* video mode routes */}
          <Route
            exact
            path="/audit/video/permission/:claimNumber"
            element={<PermissionVideo />}
          />
          <Route
            exact
            path="/audit/video/:claimNumber"
            element={<StartInspectionVideoModule/>}
          />
          <Route
            path="/video_intructions/:claimNumber"
            element={<VideoInstruction />}
          />
          <Route path="/video/:claimNumber" element={<VideoRecorder />} />
          <Route path="/videoTimer" element={<VideoTimer number={3} />} />
          <Route
            path="/processing/video/:claimNumber"
            element={<ProcessingVideo />}
          />
            <Route
              exact
              path="/audit/photoretake/permission/:claimNumber"
              element={
                <PermissionRetake />
              }
            />
            <Route
              path="/audit/photoretake/:claimNumber"
              element={
                <StartInspectionRetake />
              }
            />
            <Route path="/processingretake/:claimNumber" element={<ProcessingRetake />} /> 
          </Routes>
        </div>
      </FullscreenProvider>
    </Router>
  )
}

export default App